export default __webpack_public_path__ + "static/media/male.c5ccd21d.svg";